import type { Policy } from '@cartwhl/common/appletPolicy';

import {
  CartographerLayout,
  CartographerLayoutAccessDenied,
  CartographerLayoutLoading,
} from './Layout';
import { withProvider } from './cartographerStore';
import Cartographer from './components/Cartographer';

const CartographerWithStore = withProvider(Cartographer);

const applet = {
  id: 'cartographer',
  path: '/cartographer',
  paths: ['/cartographer'],
  label: 'Cartographer',
  description:
    'Load a rigged model, run skeleton recognition, and map IK chains with custom controls.',
  dashboard: {
    imageSrc:
      'https://resources.getcartwheel.com/share/demo-videos/cartographer-thumb.jpg',
    imageAlt: '',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/app_launcher_cartographer.webm',
    title: 'Cartographer',
    description: 'Universal motion retargeting.',
    order: 40,
  },
  policy: {
    requiresAdmin: false,
    requiresApiKey: 'soft',
    requiresLoggedIn: false,
  } satisfies Policy,
  component: CartographerWithStore,
  layout: CartographerLayout,
  loading: CartographerLayoutLoading,
  accessDenied: CartographerLayoutAccessDenied,
};

export default applet;
